var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"multi-sort":"","no-data-text":"Es liegen noch keine Daten vor.","no-results-text":"Es wurden keine Ergebnisse gefunden.","loading-text":"Lädt...","footer-props":{
                        itemsPerPageText: 'Einträge pro Seite',
                        itemsPerPageOptions: [25,50,100, -1],
                        itemsPerPageAllText: 'Alle'
                    }}})}
var staticRenderFns = []

export { render, staticRenderFns }